/* ============ WYSUWANY KOSZYK ============ */
(function(){
  var drawer=document.querySelector('[data-cart-drawer]');
  var overlay=document.querySelector('[data-cart-overlay]');
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var fmt=new Intl.NumberFormat('pl-PL',{style:'currency',currency:(drawer&&drawer.dataset.currency)||'PLN'});
  function money(c){return fmt.format(c/100)}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}

  // Gratisy: konfiguracja z sekcji produktu (zapamiętana też na inne podstrony)
  function giftCfg(){
    var el=document.querySelector('[data-gift-config]'),cfg=null;
    if(el){try{cfg=JSON.parse(el.textContent);sessionStorage.setItem('bz_gift_cfg',el.textContent)}catch(e){}}
    if(!cfg){try{cfg=JSON.parse(sessionStorage.getItem('bz_gift_cfg')||'null')}catch(e){}}
    if(cfg&&cfg.gifts&&el){
      // zdjęcie / ikonka gratisu z kafelka prezentu (do koszyka, gdy produkt-gratis nie ma zdjęcia)
      cfg.gifts.forEach(function(g){
        var t=document.querySelector('[data-gift-variant="'+g.variant+'"] .gift-ic');if(!t)return;
        var box=t.closest('[data-gift]');if(box&&box.dataset.name)g.name=box.dataset.name;
        var im=t.querySelector('img');
        if(im)g.img=im.currentSrc||im.src;
        else g.icon=(t.firstChild&&t.firstChild.nodeType===3?t.firstChild.textContent:'').trim();
      });
      try{sessionStorage.setItem('bz_gift_cfg',JSON.stringify(cfg))}catch(e){}
    }
    return cfg&&cfg.gifts&&cfg.gifts.length?cfg:null;
  }
  function isGift(it,cfg){
    if(it.properties&&it.properties._gratis)return true;
    if(!cfg)return false;
    for(var i=0;i<cfg.gifts.length;i++) if(cfg.gifts[i].variant===it.variant_id)return true;
    return false;
  }
  function giftOf(it,cfg){
    if(!cfg)return null;
    for(var i=0;i<cfg.gifts.length;i++) if(cfg.gifts[i].variant===it.variant_id)return cfg.gifts[i];
    return null;
  }
  function post(url,body){return fetch(root+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})}
  // Pilnuje, żeby każdy gratis był w koszyku dokładnie 1 raz, gdy liczba nauszników >= próg, i znikał poniżej progu
  function getCart(){return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()})}
  // synchronizacje idą po kolei (szybkie klikanie −/+ nie dubluje gratisów)
  var syncQ=Promise.resolve(),syncBusy=0;
  function syncGifts(cart){
    var stale=syncBusy>0;syncBusy++;
    var p=syncQ.then(function(){return stale?getCart():cart}).then(doSync);
    syncQ=p.catch(function(){}).then(function(){syncBusy--});
    return p;
  }
  function doSync(cart){
    var cfg=giftCfg();if(!cfg)return Promise.resolve(cart);
    var mainQty=cart.items.reduce(function(a,it){return a+(it.product_id===cfg.product&&!isGift(it,cfg)?it.quantity:0)},0);
    var updates={},adds=[],dirty=false;
    cfg.gifts.forEach(function(g){
      var want=mainQty>=g.min?1:0;
      var lines=cart.items.filter(function(it){return it.variant_id===g.variant});
      var have=lines.reduce(function(a,it){return a+it.quantity},0);
      if(have===want)return;
      dirty=true;
      if(lines.length){lines.forEach(function(l,i){updates[l.key]=(i===0?want:0)})}
      else if(want){adds.push({id:g.variant,quantity:1,properties:{_gratis:'1'}})}
    });
    // notatka „Prezenty” zgodna z tym, co faktycznie jest w koszyku
    var names=cfg.gifts.filter(function(g){return g.name&&mainQty>=g.min}).map(function(g){return g.name}).join(', ');
    var attrs=null;
    if(cfg.gifts.some(function(g){return g.name})&&((cart.attributes||{})['Prezenty']||'')!==names)attrs={'Prezenty':names};
    if(!dirty&&!attrs)return Promise.resolve(cart);
    var body={};if(Object.keys(updates).length)body.updates=updates;if(attrs)body.attributes=attrs;
    var p=Object.keys(body).length?post('cart/update.js',body):Promise.resolve();
    return p.then(function(){return adds.length?post('cart/add.js',{items:adds}):null})
      .then(getCart)
      .catch(function(){return cart});
  }

  var TRASH='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg>';

  function render(cart){
    if(!drawer)return;
    var cfg=giftCfg();
    // licznik pokazuje tylko kupowane produkty, bez gratisów
    var count=cart.items.reduce(function(a,it){return a+(isGift(it,cfg)?0:it.quantity)},0);
    drawer.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=count});
    document.querySelectorAll('.cart-count').forEach(function(e){e.textContent=count;e.hidden=count===0});
    var list=drawer.querySelector('[data-cart-items]'),empty=drawer.querySelector('[data-cart-empty]'),foot=drawer.querySelector('[data-cart-foot]');
    empty.hidden=cart.item_count>0;foot.hidden=cart.item_count===0;
    var ship=drawer.querySelector('[data-ship]');if(ship)ship.hidden=cart.item_count===0;
    var t=drawer.querySelector('.cdr-timer');if(t)t.hidden=cart.item_count===0;
    // gratisy zawsze pod produktami (numer linii zostaje oryginalny)
    var rows=cart.items.map(function(it,i){return {it:it,i:i,g:isGift(it,cfg)}});
    // gratisy w stałej kolejności z sekcji produktu (dostawa → e-book → niespodzianka)
    function gIdx(it){if(!cfg)return 99;for(var k=0;k<cfg.gifts.length;k++)if(cfg.gifts[k].variant===it.variant_id)return k;return 99}
    rows=rows.filter(function(r){return !r.g}).concat(rows.filter(function(r){return r.g}).sort(function(a,b){return gIdx(a.it)-gIdx(b.it)}));
    // rabat na całe zamówienie (np. -30 zł) rozkładamy na ceny produktów, żeby było widać jedną cenę po obniżce
    var ord=(cart.cart_level_discount_applications||[]).reduce(function(a,d){return a+(d.total_allocated_amount||0)},0);
    var mains=rows.filter(function(r){return !r.g}),base=mains.reduce(function(a,r){return a+r.it.final_line_price},0),left=ord;
    mains.forEach(function(r,k){var part=k===mains.length-1?left:Math.round(ord*r.it.final_line_price/(base||1));left-=part;r.after=r.it.final_line_price-part});
    list.innerHTML=rows.map(function(r){
      var it=r.it,i=r.i;
      if(r.g){
        var gc=giftOf(it,cfg)||{},gsrc=it.image?img(it.image,200):(gc.img||"");
        var gpic=gsrc?'<img src="'+esc(gsrc)+'" alt="" loading="lazy">':'<span class="cdr-gift-ic">'+esc(gc.icon||"🎁")+'</span>';
        var gv=(it.variant_title&&it.variant_title!=='Default Title')?'<div class="cdr-var">'+esc(it.variant_title)+'</div>':'';
        var oldp=it.original_line_price>0?'<s>'+money(it.original_line_price)+'</s>':'';
        return '<div class="cdr-item cdr-gift">'+
          '<span class="cdr-img">'+gpic+'</span>'+
          '<div class="cdr-info"><span class="cdr-title">'+esc(it.product_title)+'</span>'+gv+'<div class="cdr-gift-tag">🎁 GRATIS</div></div>'+
          '<div class="cdr-right"><span></span><div class="cdr-price">'+oldp+'<b class="cdr-free">'+(it.final_line_price>0?money(it.final_line_price):'GRATIS')+'</b></div></div>'+
        '</div>';
      }
      var variant=(it.variant_title&&it.variant_title!=='Default Title')?'<div class="cdr-var">'+esc(it.variant_title)+'</div>':'';
      var now=r.after!=null?r.after:it.final_line_price;
      var old=it.original_line_price>now?'<s>'+money(it.original_line_price)+'</s>':'';
      return '<div class="cdr-item" data-line="'+(i+1)+'" data-qty="'+it.quantity+'">'+
        '<a class="cdr-img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(img(it.image,200))+'" alt="" loading="lazy">':'')+'</a>'+
        '<div class="cdr-info"><a class="cdr-title" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+variant+
          '<div class="cdr-qty"><button type="button" data-qty-dec aria-label="Mniej">−</button><span>'+it.quantity+'</span><button type="button" data-qty-inc aria-label="Więcej">+</button></div></div>'+
        '<div class="cdr-right"><button type="button" class="cdr-del" data-remove aria-label="Usuń">'+TRASH+'</button><div class="cdr-price">'+old+'<b>'+money(now)+'</b></div></div>'+
      '</div>';
    }).join('');
    drawer.querySelector('[data-cart-total]').textContent=money(cart.total_price);
    var save=drawer.querySelector('[data-cart-save]');
    var saved=(cart.original_total_price||0)-cart.total_price;
    if(save){save.hidden=!(saved>0);save.querySelector('b').textContent=money(saved);}
    rewards(cart,cfg,saved);
    if(ship){
      var th=parseInt(drawer.dataset.threshold,10)||0;
      var left=th-cart.total_price;
      var msg=ship.querySelector('[data-ship-msg]'),fill=ship.querySelector('[data-ship-fill]');
      if(th<=0||left<=0){msg.textContent=drawer.dataset.msgOk;fill.style.width='100%';ship.classList.add('ok');}
      else{msg.textContent=drawer.dataset.msgLeft.replace('{kwota}',money(left));fill.style.width=Math.max(4,Math.round(cart.total_price/th*100))+'%';ship.classList.remove('ok');}
    }
  }
  // Pasek prezentów: przy 1 szt. zachęca do 2. sztuki (jednym kliknięciem), przy 2+ pokazuje oszczędność
  var rw=drawer&&drawer.querySelector('[data-rewards]'),rwVariants=null;
  function rewards(cart,cfg,saved){
    if(!rw)return;
    var mains=cart.items.filter(function(it){return !isGift(it,cfg)&&(!cfg||it.product_id===cfg.product)});
    var qty=mains.reduce(function(a,it){return a+it.quantity},0);
    rw.hidden=qty===0;if(!qty)return;
    var done=qty>=2,first=mains[0];
    rw.classList.toggle('done',done);
    rw.querySelector('[data-rw-fill]').style.width=done?'100%':'50%';
    rw.querySelector('[data-rw-d1]').classList.add('on');
    var d2=rw.querySelector('[data-rw-d2]');d2.classList.toggle('on',done);d2.classList.toggle('next',!done);
    var unit=Math.round(first.final_line_price/first.quantity),price=Math.max(0,unit-(parseInt(rw.dataset.off,10)||0));
    rw.querySelector('[data-rw-msg]').innerHTML=done?rw.dataset.t2.replace('{kwota}',money(saved)):rw.dataset.t1.replace('{cena}',money(price));
    var add=rw.querySelector('[data-rw-add]');add.hidden=done;
    if(done)return;
    var sel=rw.querySelector('[data-rw-size]');
    function fill(list){
      sel.innerHTML=list.map(function(v){return '<option value="'+v.id+'"'+(v.available===false?' disabled':'')+'>'+esc(v.title)+'</option>'}).join('');
      sel.value=String(first.variant_id);sel.hidden=list.length<2;
    }
    if(rwVariants)fill(rwVariants);
    else{
      fill([{id:first.variant_id,title:first.variant_title||''}]);
      var h=(first.url||'').split('?')[0].split('/products/')[1];
      if(h)fetch(root+'products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(p){rwVariants=p.variants;fill(rwVariants)}).catch(function(){});
    }
  }
  if(rw)rw.querySelector('[data-rw-btn]').addEventListener('click',function(){
    var b=this,id=parseInt(rw.querySelector('[data-rw-size]').value,10);if(!id)return;
    b.disabled=true;
    post('cart/add.js',{items:[{id:id,quantity:1}]}).then(refresh).catch(refresh).then(function(){b.disabled=false});
  });
  function refresh(){return getCart().then(syncGifts).then(function(c){render(c);return c})}
  function change(line,qty){
    drawer.classList.add('busy');
    return fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json()}).then(syncGifts).then(function(c){render(c);drawer.classList.remove('busy')})
      .catch(function(){drawer.classList.remove('busy');refresh()});
  }

  // Licznik rezerwacji koszyka
  var timerEl=drawer&&drawer.querySelector('[data-cart-timer]'),timerInt;
  function startTimer(){
    if(!timerEl)return;
    var span=(parseInt(drawer.dataset.minutes,10)||5)*60000,key='bz_cart_end',end=0;
    try{end=parseInt(sessionStorage.getItem(key),10)||0}catch(e){}
    if(!end||end<=Date.now()){end=Date.now()+span;try{sessionStorage.setItem(key,String(end))}catch(e){}}
    clearInterval(timerInt);
    function tick(){
      var d=Math.floor((end-Date.now())/1000);
      if(d<=0){end=Date.now()+span;try{sessionStorage.setItem(key,String(end))}catch(e){}d=Math.floor(span/1000)}
      timerEl.textContent=String(Math.floor(d/60)).padStart(2,'0')+':'+String(d%60).padStart(2,'0');
    }
    tick();timerInt=setInterval(tick,1000);
  }

  function open(){
    if(!drawer){window.location.href=root+'cart';return}
    drawer.classList.add('open');overlay.classList.add('open');
    drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('cdr-lock');
    startTimer();
  }
  function close(){
    if(!drawer)return;
    drawer.classList.remove('open');overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('cdr-lock');
  }
  window.BZCart={open:open,close:close,refresh:refresh,render:render,syncGifts:syncGifts};

  if(!drawer)return;
  var init=document.querySelector('[data-cart-init]');
  try{var c0=JSON.parse(init.textContent);render(c0);if(giftCfg())syncGifts(c0).then(function(c){if(c!==c0)render(c)})}catch(e){refresh()}
  overlay.addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  drawer.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-close]')){close();return}
    var item=e.target.closest('.cdr-item');if(!item)return;
    var line=parseInt(item.dataset.line,10),q=parseInt(item.dataset.qty,10);
    if(e.target.closest('[data-qty-inc]'))change(line,q+1);
    else if(e.target.closest('[data-qty-dec]'))change(line,Math.max(0,q-1));
    else if(e.target.closest('[data-remove]'))change(line,0);
  });
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-open-cart]');
    if(a){e.preventDefault();refresh().then(open)}
  });
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh()});
})();
